const initialParams = {
  offset: 0,
  limit: 10
};
export {
  initialParams
};
